import { Box, Container, Grid, Modal } from "@mui/material";
import React, { useState } from "react";
import useStyles from "../styles";
import CeroItemPair from "../../../components/CeroItemPair";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ArrowCircleLeftOutlinedIcon from "@mui/icons-material/ArrowCircleLeftOutlined";
import { getCookie } from "../../../services/cookie";
import CeroButton from "../../../components/CeroButton";
import CeroInfoPair from "../../../components/CeroInfoPair";
import Download from "../../../assets/images/Download";
import CloseIcon from "@mui/icons-material/Close";

const SupplierHumanRightsApproval = (props) => {
  const classes = useStyles();
  const { emissionData, handleCallback, handleReviewCallback } = props;
  const role = getCookie("role");
  const readOnlyMode = getCookie("read_only_mode") === "disable_edit";

  const showVerifyButtons =
    window.location.pathname.includes("/companies") && role === "auditor";
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleIconClick = (itemId) => {
    handleCallback(itemId);
  };

  const handleReviewClick = (itemId) => {
    handleReviewCallback(itemId);
  };
  const handlePdfOpen = () => {
    setIsModalOpen(true);
  };

  const handlePdfClose = () => {
    setIsModalOpen(false);
  };
  const handlePdfPopup = () => {
    return (
      <embed
        src={`${emissionData.blob_url}#toolbar=0`}
        type="application/pdf"
        width="100%"
        height="600px"
      />
    );
  };

  return (
    <Container className={classes.mainContainer}>
      {emissionData &&
        Array.isArray(emissionData) &&
        emissionData?.map((item, index) => (
          <Container key={index} className={classes.container}>
            {showVerifyButtons && (
              <Box className={classes.trainingAndProgramAction}>
                <CeroInfoPair
                  title="Status:"
                  value={
                    item.status === "pending_approval"
                      ? "Pending Approval"
                      : item.status
                      ? item.status
                      : "NA"
                  }
                  classes={{
                    container: classes.statusContainer,
                    title: classes.statusTitle,
                    value:
                      item.status === "In Progress" ||
                      item.status === "pending_approval"
                        ? classes.Inprogress
                        : classes[item?.status],
                  }}
                />
                {showVerifyButtons &&
                  emissionData.length > 1 &&
                  !readOnlyMode && (
                    <Grid container spacing={2}>
                      <Grid item xs={6}>
                        {item.status === "approved" && (
                          <div
                            className={classes.actionButtons}
                            onClick={() => handleIconClick(item.id)}
                          >
                            <CheckCircleOutlineOutlinedIcon
                              className={classes.icon}
                            />
                            <CeroButton
                              variant="contained"
                              buttonText="Validate"
                              className={classes.approveButton}
                            />
                          </div>
                        )}
                      </Grid>
                      <Grid item xs={6}>
                        {item.status === "approved" && (
                          <div
                            className={classes.actionButtons}
                            onClick={() => handleReviewClick(item.id)}
                          >
                            <ArrowCircleLeftOutlinedIcon
                              className={classes.icon}
                            />
                            <CeroButton
                              variant="contained"
                              buttonText="Review"
                              className={classes.approveButton}
                            />
                          </div>
                        )}
                      </Grid>
                    </Grid>
                  )}
              </Box>
            )}
            <CeroItemPair
              title="Supplier Name:"
              value={item.supplier_name ? item.supplier_name : "NA"}
              classes={{
                container: classes.infoContainer,
                title: classes.supplierHumanTitle,
                value: classes.value,
              }}
            />
            <CeroItemPair
              title="Risk of Child Labour:"
              value={item.risk_of_child_labor ? item.risk_of_child_labor : "NA"}
              classes={{
                container: classes.infoContainer,
                title: classes.supplierHumanTitle,
                value: classes.value,
              }}
            />
            <CeroItemPair
              title="Child Labour risk explanation:"
              value={item.child_labor_details ? item.child_labor_details : "NA"}
              classes={{
                container: classes.infoContainer,
                title: classes.supplierHumanTitle,
                value:
                  showVerifyButtons && emissionData.length > 1 && !readOnlyMode
                    ? classes.supplierHumanRights
                    : classes.value,
              }}
            />
            {emissionData.blob_url && (
              <div
                style={{
                  transform: "scale(0.6)",
                  transformOrigin: "center",
                  position: "absolute",
                  top: 100,
                  right: 100,
                }}
                onClick={handlePdfOpen}
              >
                <Download />
              </div>
            )}
            <CeroItemPair
              title="Risk of Forced or Compulsory Labour:"
              value={
                item.risk_of_compulsory_labor
                  ? item.risk_of_compulsory_labor
                  : "NA"
              }
              classes={{
                container: classes.infoContainer,
                title: classes.supplierHumanTitle,
                value: classes.value,
              }}
            />
            <CeroItemPair
              title="Forced Labour risk explanation:"
              value={
                item.compulsory_labor_details
                  ? item.compulsory_labor_details
                  : "NA"
              }
              classes={{
                container: classes.infoContainer,
                title: classes.supplierHumanTitle,
                value: classes.value,
              }}
            />
            <CeroItemPair
              title="Incidents and Remediation actions:"
              value={
                item.incident_or_action_occurred
                  ? item.incident_or_action_occurred
                  : "NA"
              }
              classes={{
                container: classes.infoContainer,
                title: classes.supplierHumanTitle,
                value: classes.value,
              }}
            />
          </Container>
        ))}
      <Modal open={isModalOpen} onClose={handlePdfClose}>
        <Box className={classes.modalContent}>
          <CloseIcon onClick={handlePdfClose} className={classes.closeButton} />
          {handlePdfPopup()}
        </Box>
      </Modal>
    </Container>
  );
};

export default SupplierHumanRightsApproval;
